import './bootstrap'
import { createApp, ref } from 'vue'
import SlideUpDown from 'vue3-slide-up-down'

const routeApp = createApp({
  props: {},
  setup() {
    const openDetail = key => {
      if (showList.value[key]) {
        showList.value[key] = false
      } else {
        showList.value[key] = true
      }
    }

    const showList = ref({})

    return {
      openDetail,
      showList,
    }
  },
})
routeApp.component('SlideUpDown', SlideUpDown)
routeApp.mount('#routeApp')

import CalendarComponent from './components/Calendar/Calendar.vue'
import CalendarDayComponent from './components/Calendar/CalendarDay.vue'

const calendarApp = createApp({})
calendarApp.component('CalendarComponent', CalendarComponent)
calendarApp.component('CalendarDayComponent', CalendarDayComponent)
calendarApp.mount('#calendar-app')


import SearchComponent from './components/Search/Search.vue'
import SearchDepartureAreaComponent from './components/Search/DepartureArea.vue'
import SearchDeparturePrefComponent from './components/Search/DeparturePref.vue'
import SearchDepartureComponent from './components/Search/Departure.vue'
import SearchDestinationAreaComponent from './components/Search/DestinationArea.vue'
import SearchDestinationPrefComponent from './components/Search/DestinationPref.vue'
import SearchDestinationComponent from './components/Search/Destination.vue'
import SearchDateComponent from './components/Search/Date.vue'
import SearchTransportationComponent from './components/Search/Transportation.vue'
import SearchTransportationCheckComponent from './components/Search/TransportationCheck.vue'
import SearchOptionComponent from './components/Search/Option.vue'
import SearchButtonComponent from './components/Search/SearchButton.vue'
import SearchDepartureSpComponent from './components/Search/DepartureSp.vue'
import SearchDestinationSpComponent from './components/Search/DestinationSp.vue'

const searchApp = createApp({})
searchApp.component('SearchComponent', SearchComponent)
searchApp.component('SearchDepartureAreaComponent', SearchDepartureAreaComponent)
searchApp.component('SearchDeparturePrefComponent', SearchDeparturePrefComponent)
searchApp.component('SearchDepartureComponent', SearchDepartureComponent)
searchApp.component('SearchDestinationAreaComponent', SearchDestinationAreaComponent)
searchApp.component('SearchDestinationPrefComponent', SearchDestinationPrefComponent)
searchApp.component('SearchDestinationComponent', SearchDestinationComponent)
searchApp.component('SearchDateComponent', SearchDateComponent)
searchApp.component('SearchTransportationComponent', SearchTransportationComponent)
searchApp.component('SearchTransportationCheckComponent', SearchTransportationCheckComponent)
searchApp.component('SearchOptionComponent', SearchOptionComponent)
searchApp.component('SearchButtonComponent', SearchButtonComponent)
searchApp.component('SearchDepartureSpComponent', SearchDepartureSpComponent)
searchApp.component('SearchDestinationSpComponent', SearchDestinationSpComponent)
searchApp.mount('#search-app')

import NavComponent from './components/Parts/nav.vue'
const navApp = createApp({})
navApp.component('NavComponent', NavComponent)
navApp.mount('#navApp')